"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generatePolyline = generatePolyline;
var _checkAngles = require("./checkAngles");
/**
 * Converts a linked array of entities into a group of polylines, with one polyline for each contour in the entities.
 * @param contour Contour, containing an array of entities (ARC and LINE only) to generate a polyline from.
 * @param tol Allowable difference between entities and resulting polyline
 * @returns A polyline approximating the contour. The polyline is an array of vertices. Endpoints of first and last entities are included--this means that closed polylines will have duplicate first/last vertices.
 */
function generatePolyline(contour, tol) {
  const polyline = [];
  for (let i = 0; i < contour.entities.length; i++) {
    const includeFirst = i === 0;
    polyline.push(...convertEntityToPolyline(contour.entities[i], tol, includeFirst));
  }
  return polyline;
}
function convertEntityToPolyline(e, tol, includeFirst) {
  switch (e.type) {
    case 'LINE':
      if (includeFirst) {
        if (e.reversed) {
          return [e.end, e.start];
        } else {
          return [e.start, e.end];
        }
      } else {
        if (e.reversed) {
          return [e.start];
        } else {
          return [e.end];
        }
      }
    case 'ARC':
      return convertArcToPolyline(e, tol, includeFirst);
    case 'CIRCLE':
      return convertArcToPolyline({
        ...e,
        type: 'ARC',
        startAngle: 0,
        endAngle: 2 * Math.PI
      }, tol, includeFirst);
  }
  return [];
}
function convertArcToPolyline(arc, tol, includeFirst) {
  // tol = r - r cos (theta/2)
  // tol / r = 1 - cos (theta/2)
  // cos (theta/2) = 1 - tol / r
  (0, _checkAngles.checkAngles)(arc);
  let cosHalfTheta = Math.max(Math.SQRT1_2, 1 - tol / arc.r); // Smallest number of vertices will be 3 (theta = 2/3 PI)
  let thetaStep = 2 * Math.acos(cosHalfTheta);
  let sa = arc.startAngle;
  let ea = arc.endAngle;
  let nSteps = Math.ceil((ea - sa) / thetaStep);
  if (arc.reversed) {
    const temp = sa;
    sa = ea;
    ea = temp;
  }
  let polyline = [];
  for (let t = includeFirst ? 0 : 1; t <= nSteps; t++) {
    let theta = sa + t / nSteps * (ea - sa);
    polyline.push({
      x: arc.x + arc.r * Math.cos(theta),
      y: arc.y + arc.r * Math.sin(theta)
    });
  }
  return polyline;
}